// src/services/authService.js

import { FetchWithAuth } from "./apiService";

const apiUrl = process.env.REACT_APP_API_URL;

export const login = async (username, password) => {
	try {
		const response = await fetch(apiUrl + "auth/login", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ username, password }),
		});

		const data = await response.json();
		return [response.ok, data.token, data.user, data.message];
	} catch (error) {
		return [false, null, null, "Errore di rete"];
	}
};

export function getAuthToken() {
	return localStorage.getItem("token");
}

export function logout(errorMsg) {
	localStorage.removeItem("token");
	//navigate to logn and pass the error message
	window.location.href = `/login?error=${encodeURIComponent(errorMsg)}`;
}

export async function changePassword(auth, oldPassword, newPassword) {
	return await FetchWithAuth(
		auth,
		"auth/update-password",
		{ oldPassword, newPassword },
		{ method: "POST" }
	);
}
